<template>
  <div class="bg-light" style="min-height: 100vh">
    <router-view/>
  </div>
</template>
